import {
  SYSTEMCONFIG_SYSTEMCONFIG_MODAL_CHANGE,
} from './constants';

export function systemConfigModalChange(visible,type) {
  return {
    type: SYSTEMCONFIG_SYSTEMCONFIG_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEMCONFIG_SYSTEMCONFIG_MODAL_CHANGE:
      return {
        ...state,
        systemConfigModalType:action.data.type,
        systemConfigModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/systemConfigModalChange.js